module.exports = __webpack_public_path__ + "static/img/logo07.254a803.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo07.jpg
// module id = mAZ/
// module chunks = 1